import React from 'react'

function renderCount (classes, loading, value) {
  if (loading) {
    return <span className={classes.countSkeleton} aria-hidden='true' />
  }
  return value
}

function renderOverduePhrase (classes, isLoadingOverdue, overdueCount) {
  if (isLoadingOverdue) {
    return (
      <>
        {renderCount(classes, true, 0)} tasks need attention.
      </>
    )
  }
  const noun = overdueCount === 1 ? 'task' : 'tasks'
  const verb = overdueCount === 1 ? 'needs' : 'need'
  return <>{overdueCount} {noun} {verb} attention.</>
}

export function buildSubtitle ({
  classes,
  meetingsRemainingCount,
  isLoadingMeetings,
  tasksDueTodayCount,
  isLoadingDueToday,
  overdueCount,
  isLoadingOverdue,
  includeOverdue,
  meetingsCopyVariant = 'today',
  allCaughtUpCopyVariant = 'default'
}) {
  const allLoaded = includeOverdue
    ? !isLoadingMeetings && !isLoadingDueToday && !isLoadingOverdue
    : !isLoadingMeetings && !isLoadingDueToday

  const meetingsLabel = meetingsRemainingCount === 1 ? 'meeting' : 'meetings'
  const tasksDueLabel = tasksDueTodayCount === 1 ? 'task' : 'tasks'

  const overdueZeroOrAbsent = includeOverdue ? overdueCount === 0 : true

  if (allLoaded && meetingsRemainingCount === 0 && tasksDueTodayCount === 0 && overdueZeroOrAbsent) {
    if (allCaughtUpCopyVariant === 'redtailNoUpcomingOrPastDue') {
      return 'You have no upcoming meetings or past due tasks.'
    }
    return "You're all caught up for today."
  }

  if (
    includeOverdue &&
    allLoaded &&
    meetingsRemainingCount === 0 &&
    tasksDueTodayCount === 0 &&
    overdueCount > 0
  ) {
    return (
      <>
        You have nothing due today.{' '}
        {renderOverduePhrase(classes, isLoadingOverdue, overdueCount)}
      </>
    )
  }

  const showOverdue = includeOverdue && (!allLoaded || overdueCount > 0)

  let meetingsLead
  if (meetingsCopyVariant === 'upcoming') {
    meetingsLead = (
      <>
        {renderCount(classes, isLoadingMeetings, meetingsRemainingCount)}
        {' '}
        {meetingsRemainingCount === 1 ? 'upcoming meeting' : 'upcoming meetings'}
      </>
    )
  } else {
    meetingsLead = (
      <>
        {renderCount(classes, isLoadingMeetings, meetingsRemainingCount)} {meetingsLabel}
      </>
    )
  }

  return (
    <>
      You have{' '}
      {meetingsLead}
      {' '}and{' '}
      {renderCount(classes, isLoadingDueToday, tasksDueTodayCount ?? 0)} {tasksDueLabel}
      {' '}due today.
      {showOverdue && (
        <>
          {' '}
          {renderOverduePhrase(classes, isLoadingOverdue, overdueCount)}
        </>
      )}
    </>
  )
}
